const prodConfig = {
  api: "https://account.rspp-centre.com",
  amo: "https://trade.rspp-centre.com/signup?type=1",
  recaptchaClientKey: "6LfGjvMZAAAAAP-WKnx_QFwqjHETGJqIL0x-Tt7G",
  cookiesDomain: "account.rspp-centre.com"
};
export default prodConfig;
